export class InfoField {
  constructor(
    public field_1: string,
    public field_2: string,
    public field_3: string,
    public href: string,
  ) {}
}
